import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'

import { Input, Padding } from '../../../..'
import { colors } from '../../../../../constants'
import { mediaQueryForBigger } from '../../../../utils'

const Width = styled.div`
    color: ${colors.black};
    font-weight: normal;
    text-align: left;

    ${mediaQueryForBigger.mobile(`
    width: 300px;
  `)}
`

const Suggestions = styled(Input)`
    background: white;
    margin-top: 1px;
    font-size: 15px;
    padding: 5px 25px;
    height: 35px;
`

const StoresList = ({ onStoreChange, onStoreInputChange, stores, storeInputValue, t }) => (
    <Padding>
        <Width>
            <Suggestions
                type="suggestions"
                onChange={onStoreChange}
                onTextChange={onStoreInputChange}
                options={stores}
                placeholder={t('Store')}
                value={storeInputValue}
            />
        </Width>
    </Padding>
)

StoresList.propTypes = {
    onStoreChange: PropTypes.func,
    onStoreInputChange: PropTypes.func,
    stores: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            value: PropTypes.string,
        })
    ),
    storeInputValue: PropTypes.string,
    t: PropTypes.func.isRequired,
}

StoresList.defaultProps = {
    onStoreChange: () => null,
    onStoreInputChange: () => null,
    stores: [],
    storeInputValue: '',
}

export default withTranslation()(StoresList)
